import { RelationshipValue, PolicyStatus } from '@general/js/enums';

// Avoid using this util function as it is superseded by `findPolicyHolder` in `MemberUtils.js` (by passing in `isChangeCover` arg as `true`)
// TODO: Cleanup this function and remove all it's references from the codebase
export const findPolicyHolder = (members) => {
  return members.find((member) => {
    if (member.relationship) {
      if (member.relationship.name) {
        return member.relationship.name.toLowerCase() === RelationshipValue.POLICY_HOLDER.toLowerCase();
      }
    }
    return false;
  });
};

export const findSpouse = (members) => {
  return members.find((member) => {
    if (member.relationship) {
      if (member.relationship.name) {
        return [RelationshipValue.SPOUSE.toLowerCase()].includes(member.relationship.name.toLowerCase());
      }
    }
    return false;
  });
};

const DEPENDENT_RELATIONSHIP_VALUES_ARRAY = [
  RelationshipValue.DAUGHTER.toLowerCase(),
  RelationshipValue.SON.toLowerCase(),
  RelationshipValue.STEP_DAUGHTER.toLowerCase(),
  RelationshipValue.STEP_SON.toLowerCase(),
  RelationshipValue.GRAND_CHILD.toLowerCase(),
  RelationshipValue.BABY.toLowerCase(),
  RelationshipValue.FOSTER_CHILD.toLowerCase(),
  RelationshipValue.OTHER.toLowerCase(),
];

const POLICY_INACTIVE_STATUS_VALUES_ARRAY = [
  PolicyStatus.CANCELLED.toLowerCase(),
  PolicyStatus.NOT_COVERED.toLowerCase(),
  PolicyStatus.REMOVED.toLowerCase(),
  PolicyStatus.SUSPENDED.toLowerCase(),
  PolicyStatus.TERMINATED.toLowerCase(),
];

export const findDependents = (members) => {
  return members.filter((el) => {
    const elRelationshipValue = el.relationship.name.toLowerCase();
    const latestMemberStatus = el.latestMemberStatus.toLowerCase();
    return DEPENDENT_RELATIONSHIP_VALUES_ARRAY.includes(elRelationshipValue) && !POLICY_INACTIVE_STATUS_VALUES_ARRAY.includes(latestMemberStatus);
  });
};
